module.exports = __webpack_public_path__ + "assets/img/1421587607454_.pic_hd.ea42cb9c.jpg";